const SCHEME={
  USEDCAR:'usedcar://scheme.che168.com',   //二手车app scheme
  AUTOHOME_USEDCAR:'autohome://usedcar'    //主软件app 二手车 scheme
}

export default SCHEME


// WEBPACK FOOTER //
// ./src/api/publicScheme.js